import { colors, fonts, menuPaper } from '../../theme';

const styles = {
  paper: {
    ...menuPaper,
    p: 1,
  },
  title: {
    fontFamily: fonts.text,
    fontSize: 17,
    fontWeight: 700,
    color: colors.text,
  },
  content: {},
  actions: {
    gap: 1,
    px: 3,
    pb: 2,
  },
};

export default styles;
